import React, { useEffect, Fragment, useState, useRef } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useDispatch } from "react-redux";
import { showToast } from "../../../components/ToastifyNotification";
import {
  GetUsers,
} from "../../../api/utility/userAPI";
import { CopyUserPermissions } from "../../../api/utility/copyUserPermissionAPI";
import { useForm } from "react-hook-form";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

const schema = yup.object().shape({
  fromUserId: yup.string().required("From User is required"),
  toUserId: yup.string().required("To User is required"),
});

const CopyUserPermission = () => {
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");

  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fromUserId = watch("fromUserId");
  const toUserId = watch("toUserId");
  /* ---------------- FETCH USERS ---------------- */
  useEffect(() => {
    const fetchUsers = async () => {
      const res = await GetUsers();
      if (res?.success) setUsers(res.data);
    };
    fetchUsers();
  }, []);

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await CopyUserPermissions(data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
        useKeyboardSubmit(handleSubmit, onSubmit);
        useEnterNavigation(formRef);

  /* ---------------- UI ---------------- */
  return (
    <Fragment>
      <Breadcrumb parent="Utility" title="User Permissions" />

      <div className="container-fluid">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h5>Copy User Permission</h5>
          </div>
          <form
            className="form theme-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="card-body">
              <div className="mb-4 col-md-4">
                <label className="form-label fw-bold">
                  Copy Permission From
                </label>
                <select className="form-select" {...register("fromUserId")}>
                  <option value="">-- Select User --</option>
                  {users.map(u => (
                    <option
                      key={u._id}
                      value={u._id}
                      disabled={u._id === toUserId}
                    >
                      {u.userName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 col-md-4">
                <label className="form-label fw-bold">
                  Copy Permission To
                </label>
                <select className="form-select" {...register("toUserId")}>
                  <option value="">-- Select User --</option>
                  {users.map(u => (
                    <option
                      key={u._id}
                      value={u._id}
                      disabled={u._id === fromUserId}
                    >
                      {u.userName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="card-footer text-end">
              <button className="btn btn-primary me-2" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default CopyUserPermission;
